// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg:hover circle[data-v-329aff66],svg:hover path[data-v-329aff66]{stroke:#6c48e9}svg.close[data-v-329aff66]{transform:rotate(180deg)}", ""]);
// Exports
module.exports = exports;
